export default {
  namespaced: true,
  state: {
    hasSubsidyPermission: false, // 是否具有差补新权限
    travelBillCanChange: true, //出差单是否可更换
    costModule: [], // 企业成本中心模块
    costModuleLoad: true, // 企业成本中心模块加载状态
    hasErrorOrderCount: 0, //错误订单数
    needTravelFormVuex: 0, //是否需要出差单
    homepageBanners: [], // 大首页banners
    enterpriseInfo: {
      agentAppName: '',
      agentLogoDist: '',
      agentName: '',
      agentPlatId: '',
      apiUrl: '',
      hostUrl: '',
      integralLogoUrl: '',
      platId: '',
      servicePhone: '',
      filingInfo: '',
    }, // 企业信息
    history: {
      hotel: [],
      flight: [],
      train: [],
    },
    IsPrivilegeStaff: false, //是否是统一代订人
  },
  getters: {
    // 启动页图片
    startLogo: (state) => `https://image.ceekee.com/tmc/${state.enterpriseInfo.agentLogoDist}/logo_load.png`,
    // 首页底部图片
    homeLogo: (state) => `https://image.ceekee.com/tmc/${state.enterpriseInfo.agentLogoDist}/logo_home.png`,
    // 登录图片
    loginLogo: (state) => `https://image.ceekee.com/tmc/${state.enterpriseInfo.agentLogoDist}/logo_login.png`,
    // 登录图片
    productLogo: (state) => `https://image.ceekee.com/tmc/${state.enterpriseInfo.agentLogoDist}/logo_product.png`,
    // appName
    appName: (state) => state.enterpriseInfo.agentAppName,
    // 企业名称
    enterpriseName: (state) => state.enterpriseInfo.agentName,
    // agentPlatId
    agentPlatId: (state) => state.enterpriseInfo.agentPlatId,
    servicePhone: (state) => state.enterpriseInfo.servicePhone,
  },
  mutations: {
    // 存储大首页banner
    setHomepageBanners(state, data) {
      state.homepageBanners = data || [];
    },
    // 存储差补权限
    setSubsidyPermission(state, data) {
      state.hasSubsidyPermission = data || false;
    },
    setTravelBillCanChange(state, data) {
      state.travelBillCanChange = data || false;
    },
    // 存储企业成本中心模块
    setCostModule(state, data) {
      state.costModule = data || [];
    },
    setCostModuleLoad(state, data) {
      state.costModuleLoad = data;
    },
    setHasErrorOrderCount(state, data) {
      state.hasErrorOrderCount = data || 0;
    },
    // 存储出差单
    setNeedTravelFormVuex(state, data) {
      state.needTravelFormVuex = data || 0;
    },
    // 存储企业信息
    updateEnterpriseInfo(state, data) {
      state.enterpriseInfo = data || {};
    },
    // 添加历史记录
    addHistory(state, datas) {
      const { type, data, keyId } = datas;
      const key = keyId || 'Name';
      // 如果历史记录中有值，把记录提到第一个,并且限制记录个数为6个
      const findItem = state.history[type].find((item) => item[key] === data[key]);
      if (findItem) {
        state.history[type].splice(state.history[type].indexOf(findItem), 1);
      }
      state.history[type].unshift(data);
      if (state.history[type].length > 12) {
        state.history[type].pop();
      }
    },
    // 清空历史记录
    clearHistory(state, type) {
      state.history[type] = [];
    },
    setIsPrivilegeStaff(state, data) {
      state.IsPrivilegeStaff = data || false;
    },
  },
  actions: {
    // 校验成本中心是否必填
    checkCostModuleRequire({ state }) {
      let flag = true;

      outerLoop: for (let i = 0; i < state.costModule.length; i++) {
        const item = state.costModule[i];
        if (item.isHide) {
          continue;
        }
        for (let j = 0; j < item.members.length; j++) {
          const member = item.members[j];
          if (member.isRequire) {
            const placeholder = item.placeholder || item.modelName;
            if (item.type === 'input') {
              if (member.items.length === 0 || !member.items[0].selectName) {
                flag = false;
                uni.showToast({
                  title: member.memberName ? `请填写${member.memberName}的${placeholder}` : `请填写${placeholder}`,
                  icon: 'none',
                  duration: 2000,
                });
                break outerLoop;
              }
            } else if (member.items.length === 0) {
              flag = false;
              uni.showToast({
                title: member.memberName ? `请选择${member.memberName}的${placeholder}` : `请选择${placeholder}`,
                icon: 'none',
                duration: 2000,
              });
              break outerLoop;
            }
          }
        }
      }
      return flag;
    },
  },
};
